import { FhToasterMessageInterface } from '../interface/fh-toaster-message-interface';

export class FhToasterMessageModel implements FhToasterMessageInterface {
  key = '';
  severity = '';
  summary = '';
  detail = '';
  life?: number;

  constructor(init?: Partial<FhToasterMessageModel>) {
    Object.assign(this, init);
  }
}
